import React, {useContext} from "react";
import {Route, Redirect, Switch} from "react-router-dom";
import PrivateRoute from "./ui-components/PrivateRoute";
import Dashboard from "./ui-components/Dashboard";
import Login from "./ui-components/pages/Login";
import Signup from "./pages/Signup";
import Registration from "./ui-components/pages/Registration";
import ResetPassword from "./ui-components/pages/ResetPassword";
import menu from "@ui-components/AppNavigation/menu";
import Logout from "./ui-components/pages/Logout";
import NotFound from "./ui-components/pages/NotFound";
import Notifications from "./ui-components/Notifications";
import {IntlProvider} from "react-intl";
import CountryContext, {LANGUAGE_KEY} from "./CountryContext";
import CountryConfigContext from "./CountryConfigContext";
import PublicHome from "./pages/PublicHome";
import ExternalAuth from "./ui-components/pages/ExternalAuth";
import FaqTriplets from "./pages/Assistant/ThemeManagement";
import {UserNotificationsContextProvider} from "./UserNotificationsContext";
import PWAInstallationHeader from "./components/PWAInstallationHeader";
import {MergeAccountsPrompt} from "@pages/Prompts";
import RevitPopupReminderComponent from "./components/RevitPopupReminderComponent";
import PublicPriceList from "@pages/PublicPriceList";

const Router = () => {

  const {country} = useContext(CountryContext);
  const {config} = useContext(CountryConfigContext);

  return (
    <IntlProvider
      messages={config.locale}
      locale={localStorage.getItem(LANGUAGE_KEY)}
      defaultLocale={"it"}
      onError={() => null}
    >
      <PWAInstallationHeader />
      <RevitPopupReminderComponent />
      <Notifications>
        <UserNotificationsContextProvider>
          <Switch>
            <PrivateRoute
              exact
              path="/"
              component={() => <Redirect to={{pathname: `/${country.code}`}}/>}
            />

            <Route path={`/${country.code}`} exact component={PublicHome}/>
            <Route path={`/${country.code}/login`} component={Login}/>
            <Route path={`/${country.code}/logout`} component={Logout}/>
            <Route path={`/external-auth`} component={ExternalAuth}/>
            <Route path={`/${country.code}/kcolor-price-list`} component={PublicPriceList}/>
            <Route exact path={[
              `/${country.code}/signup`,
              `/${country.code}/signup/:encodedUserData`
            ]} component={Signup}/>
            <Route
              exact
              path={`/${country.code}/registration/:token`}
              component={Registration}
            />
            <Route
              exact
              path={`/${country.code}/new_password/:token`}
              component={ResetPassword}
            />
            <Route
              exact
              path={`/${country.code}/kerakoll_assistant/themes`}
              component={FaqTriplets}
            />

            <PrivateRoute
              exact
              path={`/${country.code}/merge-accounts/:token`}
              component={MergeAccountsPrompt}
            />

            <PrivateRoute
              path={[
                ...menu
                  .filter((item) => {
                    if (item.countries) {
                      return item.countries.includes(country.code);
                    }
                    return true
                  })
                  .reduce(
                    // Flatten dropdown items
                    (acc, route) => [
                      ...acc,
                      ...(route.dropdown ? route.dropdown : [route]),
                    ],
                    []
                  )
                  .map((route) => `/${country.code}${route.href}`),
                `/${country.code}/profile`,
                `/${country.code}/service-configuration/:serviceId`,
                `/${country.code}/worksites/:worksite_id`,
                `/${country.code}/worksites/:worksite_id/note/:note_id`,
                `/${country.code}/worksites/:worksite_id/reference`,
                `/${country.code}/worksites/:worksite_id/reference/:reference_id`,
                `/${country.code}/service/:serviceId/survey/:surveyId`,
                `/${country.code}/worksites/:worksite_id/tasks`,
                `/${country.code}/worksites/:worksite_id/tasks/list/:task_id/:activity_id/discussion/:note_id`,
                `/${country.code}/worksites/:worksite_id/tasks/list/:task_id`,
                `/${country.code}/worksites/:worksite_id/tasks/maps/:map_id`,
                `/${country.code}/worksites/:worksite_id/documents`,
                `/${country.code}/quotations/:quotation_id`,
                `/${country.code}/quotations/:quotation_id/drafts/:draft_id`,
                `/${country.code}/quotations/:quotation_id/drafts/:draft_id/:duplicate`,
                `/${country.code}/quotations/:quotation_id/drafts/new`,
                `/${country.code}/quotations/new/:payload`,
              ]}
              component={Dashboard}
            />

            <Route path="*" component={NotFound}/>
          </Switch>
        </UserNotificationsContextProvider>
      </Notifications>
    </IntlProvider>
  );
};

export default Router;
